export default __webpack_public_path__ + "static/media/BrainBreak cards12.5918dad8.png";